<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section">
    <h2>Assurance Flotte Auto Professionnelle</h2>
    <p>
      Vous recherchez une couverture d'assurance pour votre flotte d'entreprise ? BROKINS interroge le marché de l'assurance auto afin de trouver la solution qui vous convient. Un contrat flotte auto commence généralement dès <span class="highlight-purple">trois moteurs véhicules</span>. Une solution adaptée au profil de votre parc automobile : Véhicules légers, utilitaires, véhicules de plus de <span class="highlight-purple">3,5 tonnes</span>, deux et trois roues motorisées, véhicules agricoles, engins de chantier ou remorques de moins de <span class="highlight-purple">3,5 tonnes</span>… quelle que soit la nature de votre parc automobile, nous trouvons l'offre qui s'ajuste à votre activité.
    </p>
    <p>
      Cette offre couvre également vos collaborateurs, car au-delà des dommages que peuvent subir vos véhicules, vos collaborateurs sont aussi protégés lorsqu'ils sont victimes d'un accident et pris en charge en cas d'immobilisation du véhicule. Le contrat flotte auto agit rapidement pour mieux accompagner votre entreprise, en effet, pour ne pas laisser votre entreprise trop longtemps privée des véhicules dont elle a besoin, ce contrat vous offre des garanties et des solutions d'indemnisation fiables. Par ailleurs, ce contrat vous permet la redescente automatique du parc de véhicules à partir du SIRET de l'entreprise. Il permet également de faire une pré-affectation automatique des garanties et options en fonction du profil du parc. Autre avantage majeur, l'entrée / sortie de véhicules et la modification des garanties se font en <span class="highlight-purple">3 clics</span>.
    </p>
    <p>
      Il est assez rare de trouver des assurances flotte auto professionnelle avec moins de <span class="highlight-purple">3 véhicules</span>, il sera donc nécessaire de souscrire autant d' Assurances Auto Professionnelle dont vous aurez plus d'informations <strong>ici</strong>, que de véhicules professionnels
    </p>
  </div>

  <div class="content-section bg-accent">
    <h2 class="section-title-purple">Différence avec un contrat d'assurance Auto individuel :</h2>
    <p>
      Pour souscrire un contrat flotte automobile, il faut souvent disposer d'à minima <span class="highlight-purple">5 moteurs</span>. Le contrat s'arrête souvent à <span class="highlight-purple">450</span> en gestion de parc.
    </p>
    <ul class="simple-list">
      <li>
        Ce contrat flotte automobile permet d'assurer tous les véhicules au sein d'un même contrat (véhicules légers, scooters ou motos, camions, engins de manutention et chantier, machines agricoles, remorques, etc.).
      </li>
      <li>
        Contrairement à l'assurance auto du particulier, en flotte, l'identité des conducteurs de chaque véhicule n'est pas requise et le système bonus-malus (ou CRM) ne s'applique pas aux véhicules assurés.
      </li>
      <li>
        Une seule régularisation annuelle est faite en fin d'exercice, pour l'ensemble des mouvements de véhicules et modifications de garanties.
      </li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="section-title-purple">Véhicules concernés :</h2>
    <p>Le contrat d'assurance peut couvrir <span class="highlight-purple">6 catégories</span> de véhicules possibles :</p>
    <ul class="vehicles-list">
      <li><strong>Catégorie 1</strong> Véhicules de moins de 3,5 T,</li>
      <li><strong>Catégorie 2</strong> Véhicules de plus de 3,5 T non agricoles,</li>
      <li><strong>Catégorie 3</strong> Véhicules à moteur de 2 ou 3 roues,</li>
      <li><strong>​Catégorie 4</strong> Moteurs de chantiers et de manutention,</li>
      <li><strong>Catégorie 5</strong> Remorques non agricoles, immatriculées ou non, de moins de 3,5T,</li>
      <li><strong>​Catégorie 6</strong> Engins agricoles & autres véhicules.</li>
    </ul>
  </div>

  <div class="content-section bg-light">
    <h2 class="section-title-purple">Les Garanties :</h2>
    <p>Possibilité de choisir parmi plusieurs combinaisons possibles (du <span class="highlight-purple">Pack 1</span> au <span class="highlight-purple">Pack 3</span>) les garanties suivantes :</p>
    <ul class="guarantees-list">
      <li>Responsabilité civile automobile,</li>
      <li>DPRSA,</li>
      <li>Vol & Incendie,</li>
      <li>Dommages tous accidents,</li>
      <li>Bris de glaces.</li>
    </ul>
    <p>Mais vous pouvez également ajouter les options suivantes à ajuster à votre activité :</p>
    <ul class="options-list">
      <li>Responsabilité civile de fonctionnement,</li>
      <li>Protection du conducteur,</li>
      <li>Aménagements professionnels et accessoires,</li>
      <li>Contenu professionnel et personnel,</li>
      <li>Indemnité d'immobilisation du véhicule,</li>
      <li>Pertes financières,</li>
      <li>Valeur majorée,</li>
      <li>Dommages aux pneumatiques,</li>
      <li>Absorption de corps étrangers,</li>
      <li>Frais de remorquage et levage,</li>
      <li>Assistance aux véhicules et aux personnes : En fonction de vos besoins et pour davantage de sérénité, vous pouvez également bénéficier de prestations d'assistance aux véhicules et aux personnes. L'assistance se caractérise de la sorte :</li>
    </ul>
    <p><strong>Assistance Économique :</strong> prestations d'assistance « de base », comme l'assistance <span class="highlight-purple">0km</span>,</p>
    <p><strong>Assistance Essentiel :</strong> avec véhicule de remplacement de gamme citadine/compacte,</p>
    <p><strong>Assistance Confort :</strong> avec véhicule de remplacement de gamme équivalente.</p>
    <p>Ces prestations sont assurées par le <span class="text-purple">N°1 mondial</span> du secteur de l'assistance.</p>
  </div>

  <div class="content-section">
    <h2 class="section-title-purple">Les exclusions :</h2>
    <ul class="exclusions-list">
      <li>Les activités de location de courte et de longue durée,</li>
      <li>Les transports publics de voyageurs hors risques réservés,</li>
      <li>Les flottes comportant des véhicules de deux à trois roues destinés à la livraison,</li>
      <li>Les appels d'offres de marchés publics avec cahier des charges,</li>
      <li>Les flottes de véhicules immatriculées hors de France,</li>
      <li>​La Responsabilité Civile Exploitation,</li>
      <li>La perte d'exploitation suite à immobilisation du véhicule.</li>
    </ul>
  </div>

  <div class="content-section">
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong>GENERALI, +SIMPLE, AXA, SWISSLIFE, FMA, XENASSUR, PROGEAS</strong>.
    </p>
  </div>
</app-page-layout>
